import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HttpClientXml from "../utils/HttpClientXml";
import HomeService from "../Services/HomeService";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageAppPoster() {
  const [appPosters, setAppPosters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemID, setItemID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({
    image: "",
  });

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Poster Image",
      cell: (row) => (
        <div style={{ position: "relative" }}>
          <img
            src={row.image || "/placeholder-image.png"}
            alt="App Poster"
            width="100"
            height="120"
            style={{
              borderRadius: "8px",
              objectFit: "cover",
              border: "2px solid #dee2e6",
              backgroundColor: "#f8f9fa",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "rgba(0,0,0,0.7)",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              opacity: 0,
              transition: "opacity 0.3s",
            }}
            onMouseEnter={(e) => (e.target.style.opacity = 1)}
            onMouseLeave={(e) => (e.target.style.opacity = 0)}
            onClick={() => window.open(row.image, "_blank")}
          >
            <i
              className="fa-solid fa-expand"
              style={{ color: "white", fontSize: "12px" }}
            ></i>
          </div>
        </div>
      ),
      center: true,
    },
    {
      name: "Created Date",
      selector: (row) =>
        new Date(
          row.createdAt || row.createdOn || row.updatedAt
        ).toLocaleDateString(),
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            onClick={() => handleEdit(row)}
            className="btn btn-sm me-2"
            style={{
              background: "transparent",
              border: "none",
              color: "rgb(133, 218, 79)",
            }}
          >
            <i className="fa-solid fa-pen-to-square fs-5"></i>
          </button>
          {/* <button
            title="Delete"
            onClick={() => handleDelete(row._id)}
            className="btn btn-sm"
            style={{
              background: "transparent",
              border: "none",
              color: "#dc3545",
            }}
          >
            <i className="fa-solid fa-trash-can fs-5"></i>
          </button> */}
        </div>
      ),
      center: true,
    },
  ];

  // Fetch all app posters
  const fetchAppPosters = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getAppPoster();
      console.log("App Posters data:", res.data);
      setAppPosters(res.data);
    } catch (error) {
      console.error("Error fetching app posters:", error);
      toast.error("Failed to load app posters!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAppPosters();
  }, []);

  // Handle edit button click
  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({
      image: row.image || "",
    });
    setItemID(row._id);
  };

  // Handle delete button click with SweetAlert confirmation
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete App Poster?",
      text: "Are you sure you want to delete this app download poster?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteAppPoster(id);
        if (res?.status) {
          Swal.fire("Deleted!", "App poster has been deleted.", "success");
          fetchAppPosters();
        } else {
          toast.error(res?.message || "Failed to delete poster");
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete app poster.", "error");
      }
    }
  };

  // Handle image upload
  const handleImageUpload = async (e) => {
    if (!e.target.files[0]) return;

    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setEditData({ ...editData, image: res.image });
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    }
  };

  // Handle form submission for update
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!editData.image) {
      toast.error("Please upload an image.");
      return;
    }

    try {
      // Prepare update data
      const data = {
        image: editData.image,
      };

      console.log("Updating app poster with data:", data);

      const res = await HomeService.updateAppPoster(itemID, data);

      if (res?.status) {
        toast.success("App poster updated successfully!");
        setIsEdit(false);
        setEditData({ image: "" });
        fetchAppPosters();
      } else {
        toast.error(res?.message || "Failed to update app poster.");
      }
    } catch (error) {
      toast.error("Failed to update app poster.");
      console.error("Error updating app poster:", error);
    }
  };

  // Handle cancel edit
  const handleCancel = () => {
    setIsEdit(false);
    setEditData({ image: "" });
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit ? (
            <section className="chartBox_area">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">Edit App Poster</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* Image Upload Section */}
                      <div className="col-md-6 mt-3">
                        <label>
                          App Poster Image<span className="text-danger">*</span>
                        </label>
                        {editData.image && (
                          <div className="mt-2 mb-2">
                            <img
                              src={editData.image}
                              alt="Poster Preview"
                              style={{
                                maxHeight: "200px",
                                maxWidth: "100%",
                                borderRadius: "8px",
                                border: "2px solid #dee2e6",
                                objectFit: "contain",
                                backgroundColor: "#f8f9fa",
                                padding: "10px",
                              }}
                            />
                          </div>
                        )}
                        <input
                          type="file"
                          className="form-control"
                          onChange={handleImageUpload}
                          accept="image/*"
                        />
                        <small className="text-muted">
                          Upload new app poster image
                        </small>
                      </div>
                    </div>

                    <div className="mt-4 pt-3 border-top">
                      <button
                        type="submit"
                        className="btn btn-primary me-3"
                        style={{
                          background: "rgb(133, 218, 79)",
                          border: "none",
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-floppy-disk me-2"></i>
                        Save Changes
                      </button>
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="btn btn-secondary"
                        style={{
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-times me-2"></i>
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          ) : (
            <>
              <div className="mt-5">
                <div style={headLineStyle} className="page-headline">
                  Manage App Download Poster
                </div>
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading app poster...</p>
                  </div>
                ) : appPosters.length > 0 ? (
                  <div className="card">
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={appPosters}
                        pagination={false}
                        responsive
                        highlightOnHover
                        striped
                        noDataComponent={
                          <div className="text-center py-4">
                            <i className="fa-solid fa-image fa-2x text-muted mb-3"></i>
                            <p>No app poster found</p>
                          </div>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="card">
                    <div className="card-body text-center py-5">
                      <i className="fa-solid fa-image fa-3x text-muted mb-3"></i>
                      <h5>No App Poster Available</h5>
                      <p className="text-muted">
                        There is no app download poster at the moment.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default ManageAppPoster;
